module.exports = __webpack_public_path__ + "static/media/cancel-project-icon.4c1cd14d.svg";